<div id="register" class="inner-scroll" fxLayout="row" fxLayoutAlign="start">
    <ngx-loading [show]="loading"></ngx-loading>

    <div id="register-intro" fxFlex fxHide fxShow.gt-xs>

        <div class="title" [@animate]="{value:'*',params:{delay:'50ms',y:'25px'}}">
            Get Jobs - Joburi si consultanta
        </div>

        <div class="description" [@animate]="{value:'*',params:{delay:'100ms',y:'25px'}}">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat,
            vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.
        </div>

    </div>

    <div id="register-form-wrapper" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'300ms',x:'100%'}}">
        <!--
        <div class="logo" [@animate]="{value:'*',params:{scale:'0.2'}}">
            <img src="assets/images/logos/getJobsLogo.png">
        </div>
        -->
        
        <div id="register-form"  fxLayout="row">
            <mat-vertical-stepper [linear]="true" #stepper fxFlex="100" style="width: 100%!important;">
        
                <mat-step [stepControl]="registerForm" fxFlex="100">
                    
                    <form [formGroup]="registerForm" fxFlex="100">
                        <ng-template matStepLabel>Detalii cont / delegat</ng-template>
                        
                        <div fxFlex="100">
                            
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Nume</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-icon matSuffix class="secondary-text">account_circle</mat-icon>
                                    <mat-error *ngIf="registerForm.get('name').hasError('required')"> Numele este obligatoriu </mat-error>
                                    <mat-error *ngIf="registerForm.get('name').hasError">{{ registerForm.get('name').errors?.serverError }}</mat-error>
                                </mat-form-field>
                            </div>
                    
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Email</mat-label>
                                    <input matInput formControlName="email">
                                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                                    <mat-error *ngIf="registerForm.get('email').hasError('required')">Email-ul este obligatoriu</mat-error>
                                    <mat-error *ngIf="!registerForm.get('email').hasError('required') && registerForm.get('email').hasError('email')">Te rugam sa introduci o adresa de email valida
                                    </mat-error>
                                </mat-form-field>
                            </div>
                    
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Parola</mat-label>
                                    <input matInput type="password" formControlName="password">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error>Parola este obligatorie</mat-error>
                                </mat-form-field>
                            </div>
                    
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Parola (Confirmare)</mat-label>
                                    <input matInput type="password" formControlName="password_confirmation">
                                    <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon>
                                    <mat-error *ngIf="registerForm.get('password_confirmation').hasError('required')">
                                        Confirmarea parolei este obligatorie
                                    </mat-error>
                                    <mat-error *ngIf="!registerForm.get('password_confirmation').hasError('required') &&
                                       registerForm.get('password_confirmation').hasError('passwordsNotMatching')">
                                        Parola nu este identica cu cea de mai sus
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            
                            <br>
                            <div fxLayout fxLayoutWrap fxLayoutAlign="center center">
                                <mat-button-toggle-group #entityTypeField [value]="entityTypeValue" (change)="entityTypeValue = $event.source.value" >
                                    <mat-button-toggle value="angajator">Angajator</mat-button-toggle>
                                    <mat-button-toggle value="universitate">Universitate</mat-button-toggle>
                                    <mat-button-toggle value="student">Student</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                            <br>
                            
                            <div fxLayout fxLayoutWrap style="width: 100%!important;">
                                <button mat-raised-button style="float: right" color="accent" [disabled]="registerForm.invalid" matStepperNext>Pasul urmator</button>
                            </div>
                            
                        </div>
                    </form>
                   <hr>
                </mat-step>
                
                <mat-step [stepControl]="companyForm" *ngIf="entityTypeValue !== 'student'" fxFlex="100">
                    <form [formGroup]="companyForm" fxFlex="100">
                        
                        <ng-template matStepLabel>Informatii companie</ng-template>
                        
                        <div fxFlex="100">
                            
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Denumire firma</mat-label>
                                    <input matInput formControlName="name">
                                    <mat-icon matSuffix class="disabled-text">account_circle</mat-icon>
                                </mat-form-field>
                            </div>
                    
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>CUI</mat-label>
                                    <input matInput formControlName="uniqueRegistrationCode">
                                    <mat-icon matSuffix class="disabled-text">edit_circle</mat-icon>
                                </mat-form-field>
                            </div>
    
                            <div fxLayout fxLayoutWrap>
                                <mat-form-field appearance="standard" fxFlex="100">
                                    <mat-label>Registrul comertului</mat-label>
                                    <input matInput formControlName="nrRegCom">
                                    <mat-icon matSuffix class="disabled-text">edit_circle</mat-icon>
                                </mat-form-field>
                            </div>
                    
                            <div fxLayout fxLayoutWrap style="width: 100%!important;">
                                <button mat-button matStepperPrevious style="float: left!important;">Pasul anterior</button>
                                <button mat-raised-button color="accent" style="float: right!important;" [disabled]="companyForm.invalid" matStepperNext>Pasul urmator</button>
                            </div>
                
                        </div>
                        <hr>
                    </form>
                </mat-step>
                
                <mat-step fxFlex="100">
                    
                    <ng-template matStepLabel>Finalizare inregistrare</ng-template>
                    <br>
                    <div fxLayout fxLayoutWrap style="text-align: center">

                        <wa-mat-file-upload #fileUpload="waMatFileUpload" formControlName="file" accept="image/*" style="width: 100%!important;"
                                            placeholder = 'File'
                                            [selectedText]="null"
                                            [preview]="true"
                                            (change)="onFileChange(fileUpload)"
                                            [multiple]="false">
                            <div *ngIf="entityTypeValue !== 'student'">Incarca dovada delegare companie</div>
                            <div *ngIf="entityTypeValue === 'student'">Incarca CV-ul tau</div>
                        </wa-mat-file-upload>

                    </div>
                    
                    <br>
                    
                    <div fxLayout fxLayoutWrap style="text-align: center">
                        <div class="terms">
                            <mat-checkbox #terms name="terms" formControlName="terms" aria-label="Accept" required>
                                <span>Accept</span>
                            </mat-checkbox>
                            &nbsp;
                            <a href="#" type="button" (click)="openTermsAndConditions()" >termeni si conditii</a>
                        </div>
                    </div>
    
                    <br>
    
                    <div fxLayout fxLayoutWrap style="width: 100%!important;">
                        <button style="float: left!important;" mat-button matStepperPrevious>Inapoi</button>
                        <button style="float: right!important;" mat-raised-button color="accent" [disabled]="false" (click)="onFinishRegistration()" matStepperNext>Finalizare</button>
                    </div>
                    <hr>
                </mat-step>
    
            </mat-vertical-stepper>
        </div>
    
        <div style="text-align: center!important; width: 100%!important;">
            <span class="text">Ai deja cont?</span><br>
            <a class="link" (click)="goToLogin()">Autentificare</a><br><br>
        </div>




    </div>
    
</div>
